import { Directive, ViewContainerRef } from '@angular/core';

@Directive({ selector: '[export-pane]' })
export class ExportPaneDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
